import React from "react";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "../../../components/sidebar";
import {
  Container,
  Content,
  Header,
  BackButton,
  Title,
  EmptyState,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription,
} from "./performance-report.styles";

export const PerformanceReport: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Sidebar />
      <Content>
        <Header>
          <BackButton onClick={() => navigate("/home")}>
            <span className="material-icons">arrow_back</span>
            Voltar
          </BackButton>
          <Title>Relatório de Performance</Title>
        </Header>

        <EmptyState>
          <EmptyIcon>
            <span className="material-icons">build</span>
          </EmptyIcon>
          <EmptyTitle>Em Desenvolvimento</EmptyTitle>
          <EmptyDescription>
            Este relatório será disponibilizado em breve com métricas completas de desempenho dos seus perfis.
          </EmptyDescription>
        </EmptyState>
      </Content>
    </Container>
  );
};
